module.exports = __webpack_public_path__ + "static/assets/1b3a245af9b72d6df906caba2a06ae84.gif";